import React, { useState } from 'react';
import { Button, Modal } from '@squirrellearningltd/go-teacher-components';
import { ArrowLeft } from 'react-feather';
import * as Icon from 'react-feather';
import styles from './BoomBassadors.module.scss';
import Boomer from '../../../../../images/loader-boomer.png';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import {
    GET_SCHOOL_BOOMBASSADORS,
    UPDATE_BOOMBASSADOR_SCHOOL_STATUS,
} from './graphql';
import { useEffect } from 'react';
import { getAppTokenName, getUrl, APPS } from '@squirrellearningltd/go-shared-utils';
import { APP_NAME } from '../../../../../services/constants';
import ls from 'local-storage';

const ManageBoomBassadors = ({ setCurrentView, schoolId }) => {
    const token = ls(getAppTokenName(APP_NAME));

    const [currentlySelectedBoomBassador, setCurrentlySelectedBoomBassador] =
        useState(null);
    const [showDeleteBoomBassadorDialog, setShowDeleteBoomBassadorDialog] =
        useState(false);

    const [
        getSchoolBoombassadors,
        {
            data: schoolDataBoombassadorsData,
            loading: schoolDataBoombassadorsLoading,
            error: schoolDataBoombassadorsError,
        },
    ] = useLazyQuery(GET_SCHOOL_BOOMBASSADORS, {
        variables: {
            schoolId,
        },
    });

    const [
        removeBoomBassadorFromClass,
        { loading: removeBoomBassadorLoading, error: removeBoombassadorError },
    ] = useMutation(UPDATE_BOOMBASSADOR_SCHOOL_STATUS, {
        variables: {
            schoolId,
            isBoombassador: false,
            studentIds: [currentlySelectedBoomBassador],
        },
        awaitRefetchQueries: true,
        refetchQueries: () => [
            {
                query: GET_SCHOOL_BOOMBASSADORS,
                variables: {
                    schoolId,
                },
            },
        ],
        onCompleted: () => {
            setShowDeleteBoomBassadorDialog(false);
        },
        onError: () => {
            alert(
                'There was an error removing the BoomBassador. Please try again.'
            );
        },
    });

    useEffect(() => {
        if (schoolId) {
            getSchoolBoombassadors();
        }
    }, [schoolId]);

    if (schoolDataBoombassadorsLoading) {
        return <p>Loading...</p>;
    }

    if (schoolDataBoombassadorsError) {
        return <p>{schoolDataBoombassadorsError.message}</p>;
    }

    return (
        <>
            <button
                onClick={() => setCurrentView('default')}
                className={styles.backButton}
            >
                <ArrowLeft className={styles.backButtonIcon} />
                Back To BoomReader
            </button>

            {showDeleteBoomBassadorDialog && (
                <Modal
                    closeModal={() => setShowDeleteBoomBassadorDialog(false)}
                >
                    <div className='u-text-center'>
                        <h3>
                            Are you sure you want to remove this BoomBassador
                            from this class?
                        </h3>

                        {removeBoombassadorError && (
                            <p>
                                There was an error removing the BoomBassador.
                                Please try again
                            </p>
                        )}
                        <Button
                            className='u-m-right-1 u-m-top-3'
                            disabled={removeBoomBassadorLoading}
                            onClick={() => removeBoomBassadorFromClass()}
                        >
                            {removeBoombassadorError
                                ? 'Try again'
                                : 'Yes, delete'}
                        </Button>
                    </div>
                </Modal>
            )}

            <div className={styles.dashboardContainer}>
                <div className={styles.studentsSection}>
                    {schoolDataBoombassadorsData?.getSchoolBoombassadors
                        .length ? (
                        <>
                            <div className={styles.stundentsContainer}>
                                {schoolDataBoombassadorsData.getSchoolBoombassadors.map(
                                    (boomBassador) => (
                                        <div
                                            key={boomBassador.id}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}

                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    width: '33%',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => {
                                                    window.open(`${getUrl(APPS.go_read_teacher)}${ls('go_impersonating') ? `/student/${boomBassador.id}/impersonate/` : `/student/${boomBassador.id}`}?token=${token}`, '_blank', 'noopener,noreferrer');
                                                }}
                                            >
                                                <img
                                                    src={
                                                        boomBassador?.boomerAvatarUrl
                                                            ? `${boomBassador?.boomerAvatarUrl
                                                            }?v=${boomBassador?.updatedAt.replace(
                                                                /\s/g,
                                                                ''
                                                            )}`
                                                            : Boomer
                                                    }
                                                    style={{
                                                        width: '50px',
                                                    }}
                                                />
                                                <span className='u-m-right-1'>
                                                    {boomBassador?.firstName}
                                                </span>
                                                <span>
                                                    {boomBassador?.lastName}
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    width: '33%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => {
                                                    window.open(`${getUrl(APPS.go_read_teacher)}${ls('go_impersonating') ? `/student/${boomBassador.id}/impersonate/` : `/student/${boomBassador.id}`}?token=${token}`, '_blank', 'noopener,noreferrer');
                                                }}
                                            >
                                                {boomBassador?.classes?.[0]?.name || 'No class assigned'}
                                            </div>
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    width: '33%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                }}
                                                onClick={() => {
                                                    setCurrentlySelectedBoomBassador(
                                                        boomBassador?.id
                                                    );
                                                    setShowDeleteBoomBassadorDialog(
                                                        true
                                                    );
                                                }}
                                            >
                                                <Icon.Delete color='#FF0000'></Icon.Delete>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </>
                    ) : (
                        <div className={styles.manageBoomBassadorDisclaimer}>
                            <div>
                                <Icon.Info size={30} color={'#fff'} />
                            </div>
                            <div>
                                Your school doesn’t currently have any
                                Boombassadors. To assign a reading ambassador,
                                please click “Add new BoomBassador” button and
                                assign your Boombassadors from there.
                            </div>
                        </div>
                    )}
                </div>

                <div className={styles.infoSection}>
                    <Button onClick={() => setCurrentView('addBoombassadors')}>
                        <span className='u-m-right-1'>
                            Add new BoomBassador
                        </span>
                        <Icon.PlusCircle size={15} color={'#fff'} />
                    </Button>
                    <div
                        className={`${styles.infoSectionDescription} u-m-top-2`}
                    >
                        <h2 className={styles.infoSectionSpaceBelow}>
                            What is a BoomBassador?
                        </h2>
                        <p className={styles.infoSectionSpaceBelow}>
                            A BoomBassador is a student reading ambassador
                            chosen by you to help record reading for other
                            students in their class and school.
                        </p>

                        <p className={styles.infoSectionSpaceBelow}>
                            <strong>BoomBassadors can:</strong>
                        </p>

                        <ul className={styles.infoSectionSpaceBelow}>
                            <li>
                                Search for students in their class and across the
                                school
                            </li>
                            <li>
                                Add reading logs for other students in the
                                BoomReader platform.
                            </li>
                            <li>
                                Earn rewards for regularly logging reading
                                activity in their school.
                            </li>
                        </ul>

                        <p className={styles.infoSectionSpaceBelow}>
                            <strong>BoomBassadors cannot:</strong>
                        </p>
                        <ul className={styles.infoSectionSpaceBelow}>
                            <li>
                                Delete or edit existing reading records on
                                another student’s account.
                            </li>
                            <li>
                                View, read, or contribute to teacher comments or
                                private notes.
                            </li>
                            <li>Add new books for other students.</li>
                        </ul>
                    </div>
                    <div className={styles.infoSectionBoomBassadorSchoolScheme}>
                        <h3 className={styles.infoSectionSpaceBelow}>
                            Setup a thriving reading ambassador scheme in your
                            school
                        </h3>
                        <p className={styles.infoSectionSpaceBelow}>
                            Take part in our FREE course to help embed and
                            support an active reading ambassador scheme in your
                            school. Coming soon to our new training hub.
                        </p>

                        <Button disabled>Coming soon</Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ManageBoomBassadors;
